import React, { useState, useEffect, useCallback } from 'react';
import { toast } from 'react-toastify';
import api from '../../services/api';

function EmailLogsModal({ course, academicSessionId, onClose }) {
  const [logs, setLogs] = useState([]);
  const [loading, setLoading] = useState(true);

  const load = useCallback(async () => {
    try {
      setLoading(true);
      const res = await api.get(`/paper-allocations/email-logs/${course.CourseID}/${academicSessionId}`);
      if (res.data.success) setLogs(res.data.data);
    } catch {
      toast.error('Failed to load email logs');
    } finally {
      setLoading(false);
    }
  }, [course.CourseID, academicSessionId]);

  useEffect(() => { load(); }, [load]);

  const formatDateTime = (d) => {
    if (!d) return '-';
    return new Date(d).toLocaleString('en-IN', {
      day: '2-digit', month: 'short', year: 'numeric',
      hour: '2-digit', minute: '2-digit',
    });
  };

  const roleColor = { Setter: '#1565c0', Moderator: '#6a1b9a', Valuator: '#00695c' };

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-content modal-lg" style={{ maxWidth: 900, maxHeight: '90vh' }} onClick={(e) => e.stopPropagation()}>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'start', marginBottom: 12 }}>
          <div>
            <h2 style={{ margin: 0 }}>Email Logs</h2>
            <div style={{ marginTop: 4, fontSize: 13, color: '#616161' }}>
              <strong>{course.CourseCode}</strong> &middot; {course.CourseName}
            </div>
          </div>
          <button className="btn btn-outline btn-sm" onClick={onClose}>Close</button>
        </div>

        {loading ? (
          <div style={{ textAlign: 'center', padding: 40, color: '#999' }}>Loading...</div>
        ) : logs.length === 0 ? (
          <div style={{ textAlign: 'center', padding: 40, color: '#999' }}>No emails triggered for this course yet.</div>
        ) : (
          <div style={{ overflowX: 'auto' }}>
            <table className="data-table" style={{ marginTop: 8 }}>
              <thead>
                <tr>
                  <th>Recipient</th>
                  <th>Role</th>
                  <th>Email</th>
                  <th>Subject</th>
                  <th>Template</th>
                  <th>Status</th>
                  <th>Sent At</th>
                  <th>Sent By</th>
                </tr>
              </thead>
              <tbody>
                {logs.map((l) => (
                  <tr key={l.LogID}>
                    <td><strong>{l.RecipientName}</strong></td>
                    <td>
                      <span style={{ color: roleColor[l.RecipientRole] || '#333', fontWeight: 600, fontSize: 12 }}>
                        {l.RecipientRole}
                      </span>
                    </td>
                    <td style={{ fontSize: 13, color: '#616161' }}>{l.RecipientEmail}</td>
                    <td style={{ fontSize: 13, color: '#616161', maxWidth: 180, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                      {l.EmailSubject || '-'}
                    </td>
                    <td style={{ fontSize: 12, color: '#999' }}>{l.TemplateName || '-'}</td>
                    <td>
                      <span className={`badge ${l.EmailStatus === 'Sent' ? 'badge-active' : 'badge-inactive'}`}>
                        {l.EmailStatus}
                      </span>
                      {l.ErrorMessage && (
                        <div style={{ fontSize: 11, color: '#c62828', marginTop: 2 }} title={l.ErrorMessage}>
                          {l.ErrorMessage.length > 50 ? l.ErrorMessage.slice(0, 50) + '...' : l.ErrorMessage}
                        </div>
                      )}
                    </td>
                    <td style={{ fontSize: 12, color: '#616161', whiteSpace: 'nowrap' }}>{formatDateTime(l.SentAt)}</td>
                    <td style={{ fontSize: 12, color: '#616161' }}>{l.SentByName || '-'}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </div>
    </div>
  );
}

export default EmailLogsModal;
